import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-checkbox-field',
  templateUrl: './checkbox-field.component.html',
  styleUrl: './checkbox-field.component.css'
})
export class CheckboxFieldComponent implements ICellRendererAngularComp {
  
  isReports: boolean;

  constructor() {}

  currentField: any;
  refresh(_params: ICellRendererParams): boolean {
    return false
  }
  params;

  agInit(params): void {
    this.params = params;
    const isAllTab = localStorage.getItem('clickedAllTab')
    if(window?.location?.pathname === '/reports' && isAllTab === 'true') {
      // Flag to set Reports -> All tab fields to be Non-editable. As Only Legit Planned Date, Legit Complete, Overall Status Comment, Status, Overall Evaluation
      this.isReports = true
    }
  }

  get displayCheckboxValue(): string {
    this.currentField = this.params?.column?.colId
    const context = this.params.context;
    const tempData = context.tempEditData?.[this.params.node.id];
    if (this.params?.data?.editable && tempData) {
      return tempData[this.params.colDef.field];
    }
    return this.params?.data[this.params.colDef.field];
  }

  get showCheckboxValidationError(): boolean {
    const context = this.params.context;
    return (
      (this.currentField === 'contingencyplan' || this.currentField === 'contigencyplansummary') &&
      !context.isContingencyValid(this.params.node.id)
    );
  }


  onCheckboxValueInput(newValue: any) {
    const context = this.params.context;
    const tempData = context.tempEditData?.[this.params.node.id];
    if (tempData) {
      tempData[this.params.colDef.field] = newValue;
      if(this.currentField === 'contingencyplan') {
        this.params.api.refreshCells({
          rowNodes: [this.params.node],
          columns: ['contigencyplansummary'],
          force: true
        });
      }
    }
  }
}
